import {Component, Input, OnInit } from '@angular/core';
import { UserService } from '@sharedcommon/services/user.service';
import { PrimengTableService } from '../primeng-table.service';

@Component({
  selector: 'neq-primeng-table-date-filter',
  templateUrl: './primeng-table-date-filter.component.html',
  styleUrls: ['./primeng-table-date-filter.component.scss']
})
export class PrimengTableDateFilterComponent implements OnInit {

  /**
   * Column identifier.
   */
  @Input() field: string;

  /**
   * Unique session Id used to store filter/pagination/sort
   */
  @Input() sessionId: string ;

  startDate: Date ;
  endDate: Date ;

  constructor(
    private userService: UserService
  ) {
  }

  ngOnInit(): void {
    this.restoreFilterVal();
  }

  disableApplyButton(): boolean {
    return !(this.startDate && this.endDate) ;
  }

  returnDateFormat(): string {
    return this.userService.returnUserDateFormat();
  }

  /**
   * Apply calendar filter only when two date are selected and close the filter menu
   * @param filter
   * @param dataTableFilter
   */
  applyCalendarFilter(filter, dataTableFilter) {
    if (!this.disableApplyButton()) {
      this.endDate.setHours(23, 59, 59);
      this.startDate.setHours(0, 0, 0);
      filter([this.startDate, this.endDate]);
      dataTableFilter.overlayVisible = false;
      dataTableFilter.dt.cd.markForCheck();
    }
  }

  clearFilter(dataTableFilter: any) {
    dataTableFilter.clearFilter() ;
    dataTableFilter.overlayVisible = false;
    this.endDate = null ;
    this.startDate = null ;
  }

  /**
   * Function which restores filter values
   */
  restoreFilterVal(): void {
    const tableKeyName: string = PrimengTableService.getTableStateKey(this.sessionId) ;
    /* Retrieve the selection */
    const tableDataStr: string = localStorage.getItem(tableKeyName) ;
    if (tableDataStr) {
      try {
        const tableData: any = JSON.parse(tableDataStr) ;
        const filterValueOfField: any[]= tableData?.filters?.[this.field]?.[0]?.value ;
        if (filterValueOfField && filterValueOfField.length === 2) {
          this.startDate = new Date(filterValueOfField[0]) ;
          this.endDate = new Date(filterValueOfField[1]) ;
        }
      } catch(e) {
        /* Can be here is there is an error thrown by JSON.parse
         * In taht cas we do nothing */
      }
    }
  }
}
